import React from "react";
import { BoardButton } from "../../components/ui/BoardButton";

export const MaterialSelector = ({ items, activeItem, onSelect }) => {
  return (
    <div className="styling-wrap__type">
      <p className="marcellus-25-400">Izaberite materijal</p>
      <div className="styling-wrap__type-items poppins-18-500">
        {items?.map((item, i) => (
          <BoardButton
            key={i}
            item={item}
            activeItem={activeItem}
            setActiveItem={onSelect}
          />
        ))}
      </div>
    </div>
  );
};
